import { Configuration, ConsumerConfig } from "./configuration";

export const defaultConsumerConfig: ConsumerConfig = {
    consumerInterval: 1,
    commitOffsetStep: 1,
    group: "0",
};

export const defaultConfig: Configuration = {
    nodes: 2,
    partitions: 2,
    replicas: 2,
    producerInterval: 1,
    consumers: [defaultConsumerConfig],
};
